import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.lookit.primarybutton');
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'wiz-component-lookit-primarybutton',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.lookit.primarybutton/view.scss */
:host {
  display: block;
  min-width: 0;
}

.lookit-primary-button {
  display: inline-flex;
  min-width: 0;
  min-height: var(--lookit-touch-button);
  align-items: center;
  justify-content: center;
  gap: var(--lookit-space-2);
  border: 1px solid var(--lookit-color-text);
  border-radius: var(--lookit-radius-md);
  background: var(--lookit-color-text);
  color: var(--lookit-color-surface);
  padding: 8px var(--lookit-space-4);
  font-size: var(--lookit-font-size-sm);
  font-weight: var(--lookit-font-weight-black);
  line-height: 1.2;
  text-align: center;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease, transform 160ms ease;
}

.lookit-primary-button.is-full {
  width: 100%;
}

.lookit-primary-button:active {
  transform: scale(0.98);
}

.lookit-primary-button:disabled {
  cursor: default;
  opacity: 0.55;
}

.lookit-primary-button.is-secondary {
  border-color: var(--lookit-color-accent-strong);
  background: var(--lookit-color-accent-strong);
  color: var(--lookit-color-on-accent);
}

.lookit-primary-button.is-quiet {
  border-color: var(--lookit-border-medium);
  background: var(--lookit-color-surface);
  color: var(--lookit-color-text);
}

.lookit-primary-button__icon {
  display: grid;
  width: 20px;
  height: 20px;
  flex: 0 0 auto;
  place-items: center;
}

.lookit-primary-button__icon svg {
  width: 19px;
  height: 19px;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.lookit-primary-button__label {
  display: block;
  min-width: 0;
  overflow-wrap: anywhere;
  white-space: normal;
}`],
})
export class ComponentLookitPrimarybuttonComponent {
    @Input() label: string = '확인';
    @Input() icon: string = '';
    @Input() variant: 'primary' | 'secondary' | 'quiet' = 'primary';
    @Input() fullWidth: boolean = false;
    @Input() disabled: boolean = false;
    @Input() loading: boolean = false;
    @Input() type: 'button' | 'submit' | 'reset' = 'button';
    @Output() pressed = new EventEmitter<MouseEvent>();

    public onClick(event: MouseEvent) {
        if (this.disabled || this.loading) return;
        this.pressed.emit(event);
    }
}

export default ComponentLookitPrimarybuttonComponent;